import { Box, ListItem, ListItemText, useTheme } from "@mui/material";
import * as React from "react";

import { EditFieldButton } from "@/shared/components";
import { UpdateTriggerRequest } from "@/shared/domain/actions/TriggerRecord";

import { ActionInputData } from "../action";

interface EditableInputDataProps {
  title: string;
  field: string;
  value: string[];
  onChange: (updates: UpdateTriggerRequest) => void;
  setErrorText: (arg: string) => void;
  minRequired: number;
}

export const EditableInputData: React.FC<EditableInputDataProps> = ({
  title,
  field,
  value,
  onChange,
  setErrorText,
  minRequired,
}) => {
  const theme = useTheme();

  const [showEditableIcon, setShowEditableIcon] = React.useState(false);
  const [editable, setEditable] = React.useState(false);
  const [requiredInputs, setRequiredInputs] = React.useState<string[]>(value);

  const updateRecord = () => {
    setErrorText("");

    onChange({
      [field]: requiredInputs.filter(
        (requiredInput) => requiredInput.trim() !== "",
      ),
    });
  };

  const onClick = () => {
    if (editable) {
      updateRecord();
    }
    setEditable(!editable);
  };

  return (
    <ListItem
      onMouseOver={() => {
        setShowEditableIcon(true);
      }}
      onMouseLeave={() => {
        setShowEditableIcon(false);
      }}
    >
      <ListItemText
        primaryTypographyProps={{
          component: "span",
        }}
        sx={{
          mt: theme.spacing(0.5),
        }}
        primary={
          <>
            <span>{title}</span>
            <EditFieldButton
              editable={editable}
              showEditableIcon={showEditableIcon}
              onClick={() => {
                void onClick();
              }}
            />
          </>
        }
        secondaryTypographyProps={{
          component: "span",
        }}
        secondary={
          <>
            <Box>
              {editable === false ? (
                <>
                  {<pre>{JSON.stringify(requiredInputs, null, 2)}</pre> ||
                    "None"}
                </>
              ) : (
                <Box sx={{ mt: theme.spacing(1) }}>
                  <ActionInputData
                    inputData={
                      requiredInputs && requiredInputs.length > 0
                        ? requiredInputs
                        : [""]
                    }
                    setInputData={setRequiredInputs}
                    minRequired={minRequired}
                  />
                </Box>
              )}
            </Box>
          </>
        }
      />
    </ListItem>
  );
};
